import dayjs from 'dayjs';
import localStorage from '@/utils/local-store';

const PREFIX = 'fv-';
const prefix = (id) => `${PREFIX}${id}`;

export function add(id, type) {
    localStorage.set(prefix(id), { d: new Date(), t: type });
}

export function toggle(id, type) {
    const favorite = get(id);
    if (!favorite) {
        add(id, type);
    } else {
        remove(id);
    }
}

export function remove(id) {
    localStorage.remove(prefix(id));
}

export function get(id) {
    return localStorage.get(prefix(id));
}

export function getAll() {
    const favorites = [];
    localStorage.each((value, key) => {
        if (key.startsWith(PREFIX)) {
            favorites.push({ id: key.replace(PREFIX, ''), ...value });
        }
    });
    const sortByAdded = (a, b) => (dayjs(a.d).isAfter(dayjs(b.d)) ? 1 : -1);
    return favorites.sort(sortByAdded);
}

export function has(id) {
    return !!get(id);
}

export function clearAll() {
    getAll().forEach(({ id }) => {
        remove(id);
    });
}

export default {
    has,
    add,
    toggle,
    remove,
    get,
    getAll,
    clearAll,
};
